import { PageDeTexte, SectionDeTexte } from '../shared/ui/PageDeTexte';

/**
 * ═══════════════════════════════════════════════════════════════════════════
 * **PAGE 7 DES HUIT — LA PAGE JURIDIQUE, ET ELLE INAUGURE LE GABARIT.**
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * F-69 : « **la page juridique existe avec un texte de remplacement**, et le site porte **un
 * gabarit de page de texte réutilisable** : si l'équipe juridique remet plusieurs documents,
 * le gabarit sert autant de fois qu'il faut **sans que le périmètre bouge**. »
 *
 * ───────────────────────────────────────────────────────────────────────────
 * **LE TEXTE EST UN TEXTE DE REMPLACEMENT, ET IL LE DIT.**
 * ───────────────────────────────────────────────────────────────────────────
 *
 * F-69 : « **quelles pages la loi exige et ce qu'elles disent restent hors de cette
 * pipeline.** **Ce qui est du périmètre est ce que le site RÉSERVE.** » Et §12 range « la
 * rédaction des pages juridiques » hors périmètre, tandis que §13 fixe le comportement
 * attendu : « l'équipe juridique n'a pas remis son texte au lancement → **la page juridique
 * est en ligne avec son texte de remplacement** ».
 *
 * **CE FICHIER NE CONTIENT DONC AUCUN ENGAGEMENT JURIDIQUE, ET IL NE DOIT PAS EN CONTENIR.**
 * Écrire ici un texte qui *ressemble* à des mentions légales serait le pire des trois états
 * possibles : ni juste, ni visiblement absent. Chaque section nomme **ce qu'elle réservera**,
 * et rien de plus.
 *
 * **Remplacer ce texte est une livraison de code**, F-69 : « faite une fois. **Ce n'est pas
 * une saisie** : rien du site n'est administrable hors les colonnes d'une structure. »
 *
 * ───────────────────────────────────────────────────────────────────────────
 * **UN DOCUMENT DE PLUS N'EST PAS UNE PAGE DE PLUS.**
 * ───────────────────────────────────────────────────────────────────────────
 *
 * La liste des huit est **fermée**. Si l'équipe juridique remet trois documents au lieu d'un,
 * ils deviennent **trois `SectionDeTexte` sur cette page**, et le périmètre ne bouge pas.
 * C'est exactement ce que « le gabarit sert autant de fois qu'il faut sans que le périmètre
 * bouge » veut dire, et c'est la raison pour laquelle le gabarit existe.
 */
export function PageJuridique() {
  return (
    <PageDeTexte titre="Mentions légales" enAttenteDuTexteReel>
      <SectionDeTexte titre="Éditeur du site">
        <p>
          Cette section portera l’identité de l’éditeur, sa forme juridique, son
          siège et son immatriculation.
        </p>
      </SectionDeTexte>

      <SectionDeTexte titre="Hébergement">
        <p>
          Cette section portera l’identité de l’hébergeur du site et de
          l’application, et le lieu de traitement des données.
        </p>
      </SectionDeTexte>

      <SectionDeTexte titre="Données personnelles">
        <p>
          Cette section portera ce qui est conservé, pendant combien de temps, et
          par quel chemin une personne obtient ses données ou leur effacement.
        </p>
        <p>
          Ce que le site public sait de vous, en revanche, est déjà réglé et ne
          dépend d’aucun texte à venir : il ne compte pas les visites, ne dépose
          aucun identifiant à cette fin, et ne conserve rien de votre passage.
          Seule la page qui porte le formulaire de contact affiche un bloc d’une
          autre plateforme, et elle demande votre accord avant de l’afficher.
        </p>
      </SectionDeTexte>

      <SectionDeTexte titre="Conditions d’utilisation">
        <p>
          Cette section portera les conditions applicables aux structures
          clientes et aux personnes qui utilisent le produit.
        </p>
      </SectionDeTexte>

      <SectionDeTexte titre="Propriété intellectuelle">
        <p>
          Cette section portera la titularité des droits sur le produit, sur son
          contenu et sur les marques citées.
        </p>
      </SectionDeTexte>
    </PageDeTexte>
  );
}
